import { render, staticRenderFns } from "./PromoToProduct.vue?vue&type=template&id=f3aad85a&scoped=true"
import script from "./PromoToProduct.vue?vue&type=script&lang=js"
export * from "./PromoToProduct.vue?vue&type=script&lang=js"
import style0 from "./PromoToProduct.vue?vue&type=style&index=0&id=f3aad85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aad85a",
  null
  
)

export default component.exports